import React, { useState } from "react";
import PageWrapper from "../../Components/PageWrapper";
import List from "./List";
import Layout from "../../Layout/Layout";

export default function AdvisorsList() {
    const [activeTab, setActiveTab] = useState("all");

    return (
        <Layout>
            <PageWrapper>
                <div>
                    {/* Tabs */}
                    <div className="text-center bg-white p-2 m-1">
                        <div className="row align-items-center">
                            <div className="col-md-9">
                                <ul className="nav nav-pills">
                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === "all" ? "active" : ""}`}
                                            onClick={() => setActiveTab("all")}
                                        >
                                            All
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === "employees" ? "active" : ""}`}
                                            onClick={() => setActiveTab("employees")}
                                        >
                                            Employees
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === "advisors" ? "active" : ""}`}
                                            onClick={() => setActiveTab("advisors")}
                                        >
                                            Advisors
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {/* Pass activeTab to List */}
                    <List activeTab={activeTab} />
                </div>
            </PageWrapper>
        </Layout>
    );
}
